import {createSelector} from 'reselect';


const albumMediasItemsSelector = state => state.albumMediasMulti;
const albumIdSelector = (_, props) => props._id;
const albumParamIdSelector = (_, props) => props.match.params.albumId;


export const mediasByAlbumId = createSelector(
    albumMediasItemsSelector,
    albumIdSelector,
    (medias, key) => medias[key] || medias['default']
);

export const mediasByAlbumParamId = createSelector(
    albumMediasItemsSelector,
    albumParamIdSelector,
    (medias, albumId) => Object.values(medias).filter((media) => media.album === albumId)
);



export const mediasKeysByAlbumParamId = createSelector(
    mediasByAlbumParamId,
    medias => medias.map(media => media._id)
);